
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import analytics from '@/utils/analytics';

interface LessonNavigationProps {
  dayNumber: number;
}

const LessonNavigation: React.FC<LessonNavigationProps> = ({ dayNumber }) => {
  const navigate = useNavigate();

  const goToPreviousDay = () => {
    const previousDay = dayNumber > 1 ? dayNumber - 1 : 1;
    analytics.trackUserAction('navigation', { from: dayNumber, to: previousDay, direction: 'previous' });
    navigate(`/lesson/${previousDay}`);
  };

  const goToNextDay = () => {
    const nextDay = dayNumber < 30 ? dayNumber + 1 : 30;
    analytics.trackUserAction('navigation', { from: dayNumber, to: nextDay, direction: 'next' });
    navigate(`/lesson/${nextDay}`);
  };

  return (
    <div className="mb-8 flex justify-between items-center">
      <Button variant="outline" size="sm" onClick={goToPreviousDay} disabled={dayNumber <= 1}>
        <ChevronLeft className="mr-2 h-4 w-4" />
        Previous
      </Button>
      <div className="text-lg font-semibold">Day {dayNumber}</div>
      <Button variant="outline" size="sm" onClick={goToNextDay} disabled={dayNumber >= 30}>
        Next
        <ChevronRight className="ml-2 h-4 w-4" />
      </Button>
    </div>
  );
};

export default LessonNavigation;
